import React from "react";
import Typography from "@mui/material/Typography";
import { Box, Button } from "@mui/material";
import {
  createTheme,
  ThemeProvider,
  StyledEngineProvider,
} from "@mui/material/styles";

const theme = createTheme({
  typography: {
    fontFamily: "Proximanova Reg, sans-serif",
    button: {
      textTransform: "none",
      borderRadius: "5px",
    },
    variant: "title",
  },
});

function VmsCodeForm({ lastCode, message, handleCancel, handleSubmit }) {
  return (
    <>
      <Box
        display="flex"
        justifyContent="center"
        m={1}
        p={1}
        bgcolor="background.paper"
      >
        <StyledEngineProvider injectFirst>
          <ThemeProvider theme={theme}>
            <Typography>{message}</Typography>
          </ThemeProvider>
        </StyledEngineProvider>
      </Box>
      <Box display="flex" justifyContent="center" m={1} p={1}>
        <Box p={1}>
          <Button
            variant="contained"
            className="warningBtn"
            onClick={handleCancel}
          >
            Back
          </Button>
        </Box>
        <Box p={1}>
          <Button
            variant="contained"
            className="successBtn"
            onClick={handleSubmit}
            disabled={lastCode ? false : true}
            style={{ opacity: lastCode ? 1 : 0.5 }}
          >
            Confirm
          </Button>
        </Box>
      </Box>
    </>
  );
}

export default VmsCodeForm;
